(function () {
  'use strict';

  /* @ngdoc service
   * @name itecAdministracio.permisos.categories:usuarisHeaderSubmenuLinks
   * @description
   *
   */
  angular
    .module('itecAdministracio.entitats')
    .value('entitatsHeaderSubmenuLinksValue',  {
      'name'     : 'entitats.main',
      'addPermit': 'AFEGIRENT',
      'options'  : {
          '0': {
            'name'         : 'DEFAULT_DADES_GENERALS',
            'state'        : 'entitats.main.submain.dades',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'ENTITATMENU',
            'stateOptions' : {'reload': 'entitats.main.submain'}
          },
           '1': {
            'name'         : 'DEFAULT_ADMINISTRADORS',
            'state'        : 'entitats.main.submain.administradors',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'ADMINISTRADORSENTMENU',
            'stateOptions' : {'reload': 'entitats.main.submain'}
          },
           '2': {
            'name'         : 'SUBSCRIPCIONS',
            'state'        : 'entitats.main.submain.llicencies',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'PRODUCTEENTMENU',
            'stateOptions' : {'reload': 'entitats.main.submain'}
          },
          '3': {
           'name'         : 'USUARIS_SESSIO_TITOL',
           'state'        : 'entitats.main.submain.sessions',
           'icon'         : '',
           'show'         : false,
           'onclick'      : '',
           'permit'       : 'USUARISSESSIO',
           'stateOptions' : {'reload': 'entitats.main.submain'}
         },
          '4': {
            'name'         : 'DEFAULT_LOGOS',
            'state'        : 'entitats.main.submain.logos',
            'icon'         : '',
            'show'         : false,
            'onclick'      : '',
            'permit'       : 'LOGOSMENU',
            'stateOptions' : {'reload': 'entitats.main.submain'}
          }
      }
    });
}());
